import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import user from './modules/user';
import auth from './modules/auth';
import goodsRelease from './modules/goodsRelease';
import goodsBorrow from './modules/goodsBorrow';
import advertising from './modules/advertising';
import energyOvertime from './modules/energyOvertime';
import myActivity from './modules/myActivity';
import space from './modules/space';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    goodsRelease,
    advertising,
    goodsBorrow,
    energyOvertime,
    auth,
    myActivity,
    space
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: 'IOC_SERVICES_H5_VUEX',
    }),
  ],
});
